import { useState } from "react";
import parse from "html-react-parser";
import { motion } from "framer-motion";
import { getBlockId } from "../../../../utils/forms/form.fields.utils";

import Exterior from "../../../../Assets/svg/Exterior.svg";
import Interior from "../../../../Assets/svg/Interior.svg";
import Performance from "../../../../Assets/svg/Performance.svg";
import Safety from "../../../../Assets/svg/Safety.svg";
import Technology from "../../../../Assets/svg/Technology.svg";
import Comfort from "../../../../Assets/svg/Comfort.svg";
import { Icon } from "../../Icons/generic";

const FeaturesComponent = props => {

	const { block } = props;
	const [activeIndex, setActiveIndex] = useState(0);

	const triggerFeature = (index) => {
		setActiveIndex(index);
	}

	const features = {
		active: { opacity: 1 },
		inactive: { opacity: 0 }
	}

	const getImageIcon = (icon) => {
		switch (icon) {
			case "comfort":
				return <Comfort fill="white" stroke="white" height="30" width="30" />;
			case "exterior":
				return <Exterior fill="white" stroke="white" height="45" width="45" />;
			case "interior":
				return <Interior fill="white" stroke="white" height="45" width="45" />;
			case "performance":
				return <Performance fill="white" stroke="white" height="35" width="35" />;
			case "safety":
				return <Safety fill="white" stroke="white" height="30" width="30" />;
			case "technology":
				return <Technology fill="white" stroke="white" height="30" width="30" />;
			default:
				break;
		}
	}

	return (
		<div className="customContainer clear" id={getBlockId(block)}>
			{/* Create feature gallery here */}
			{/* Assets will fade in and out. */}
			<div className="productFeatures" id={block.data.navTitle ? block.data.navTitle.toLowerCase().replace(/ /g, '_') : ''}>
				<h2 className="cbTitle">{block.data.title}</h2>
				<div className="productFeaturesHolder">
					{block.data.children.map((feature, i) => {
						return (
							<motion.div
								className="feature"
								animate={activeIndex === i ? "active" : "inactive"}
								initial="inactive"
								variants={features}
								transition={{ type: 'tween', duration: 0.5 }}
								key={`feature-${feature.data.image.id}-${i}`}
								style={{ zIndex: `${97 + (activeIndex == i ? 1 : 0)}` }}
							>
								<div className="contentHolder" style={{ backgroundImage: `url(${feature.data.image.url})` }}>
									<div className="faded">
										<div className="content">
											<h3>{feature.data.title}</h3>
											<div className="copy">
												{feature.data.description ? parse(feature.data.description) : ""}
											</div>
										</div>
									</div>
								</div>
							</motion.div>
						);
					})}
					<ul className="featureSteps">
						{block.data.children.map((feature, i) => {
							return (
								<li
									className={`item ${activeIndex === i ? "active" : ""
										}`}
									key={`featureLi-${feature.data.image.id}-${i}`}
									onClick={() => { triggerFeature(i) }}
								>
									<div className="icon">
										{feature.data.icon.set == "font-awesome" ? (
											<Icon
												className="font-awesome"
												icon={{ type: feature.data.icon.type, icon: feature.data.icon.icon }}
											/>
										) : (
											<div className="custom-icon">
												{getImageIcon(feature.data.icon.icon)}
											</div>)
										}
									</div>
								</li>
							);
						})}
					</ul>
				</div>
			</div>
		</div>
	);
};

export default FeaturesComponent;